import { createUseStyles } from 'react-jss'
import { mediumGrey } from '../../../styles/const/colors'

const useStyles = createUseStyles({
  maxLengthMessage: {
    color: mediumGrey,
    fontSize: 10,
    paddingTop: 4,
    paddingLeft: 8,
    lineHeight: '14px',
    textAlign: 'left'
  }
})

export default useStyles
